/// FOURJS_START_COPYRIGHT(D,2018)
/// Property of Four Js*
/// (c) Copyright Four Js 2018, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("OverlayService", ["InitService"], function (context, cls) {
  /**
   * Service to display or hide an overlay which intercepts all mouse events.
   * Overlay can be invisible or visible (grey)
   * @namespace gbc.OverlayService
   * @gbcService
   * @publicdoc
   */
  class OverlayService /** @lends gbc.OverlayService */ {
    constructor() {
      /**
       * Map which contains all overlay defined during application life
       * @type {Map}
       */
      this._overlayList = null;
    }

    /**
     * Initialize the overlay management service
     */
    init() {
      this._overlayList = new Map();
    }

    /**
     * Create a new overlay object composed of element and custom flags
     * @returns {{timer: Function, visible: boolean, active: boolean, element: HTMLElement}}
     * @private
     */
    _create() {
      const overlayElement = document.createElement("div");
      overlayElement.classList.add("overlay", "hidden");
      return {
        element: overlayElement,
        active: false,
        visible: false,
        timer: null
      };
    }

    /**
     * Get the overlay associated with provided name
     * @param {string} name - overlay identifier
     * @returns {{timer: Function, visible: boolean, active: boolean, element: HTMLElement}} return overlay object
     * @publicdoc
     */
    get(name) {
      let overlay = this._overlayList.get(name);
      if (!overlay) {
        // create new overlay
        overlay = this._create();
        this._overlayList.set(name, overlay);
      }
      return overlay;
    }

    /**
     * Enable global overlay
     * @param {string} name - overlay identifier used to create and manage an associated overlay element
     * @param {HTMLElement} parentContainer - DOM element which contains overlay div. If none we add overlay directly under body
     * @publicdoc
     */
    enable(name, parentContainer) {
      const overlay = this.get(name);
      overlay.active = true;
      const containerElement = parentContainer || document.body;
      if (overlay.element.parentNode !== containerElement) {
        containerElement.appendChild(overlay.element);
      }
      overlay.element.classList.remove("hidden");
    }

    /**
     * Disable global overlay
     * @param {string} name - overlay identifier
     * @publicdoc
     */
    disable(name) {
      const overlay = this.get(name);
      overlay.active = false;
      overlay.visible = false;
      overlay.element.classList.add("hidden");
      overlay.element.classList.remove("greybg");
    }

    /**
     * Define a cursor to put over the given overlay
     * @param {String} name - name of the overlay
     * @param {String} cursor - cursor to put over
     */
    setCursor(name, cursor) {
      const overlay = this.get(name);
      overlay.element.style.cursor = cursor;
    }
  }

  gbc.OverlayService = new OverlayService();
  context.InitService.register(context.OverlayService);
});
